import { useEffect } from 'react';
import { supabase } from '@/lib/supabase/client';
import { clearAllCaches } from '@/lib/utils/cache';

/**
 * Drop every cached copy of server data when the user signs out, so the next sign-in
 * (same or different user, same device) starts from a fresh fetch.
 *
 * Listens for SIGNED_OUT rather than wrapping signOut(): it also covers a session that
 * ends in another tab or because the refresh token expired.
 */
export function useClearCachesOnSignOut(): void {
  useEffect(() => {
    const {
      data: { subscription }
    } = supabase.auth.onAuthStateChange(event => {
      if (event === 'SIGNED_OUT') {
        void clearAllCaches();
      }
    });
    return () => subscription.unsubscribe();
  }, []);
}
